import { Button, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { GET_DIGITALIZATION_APP_USERS } from "../../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../../apiServices/common";
import AppContent from "../../../../common/AppContent";
import HandleNotification from "../../../../common/Notification";
import AppPageHeader from "../../../../common/PageHeader";
import { onDeleteUser, onGetUserDetails } from "../../../../redux/actions";
import { USER_CREATE_PERMISSION } from "../../../../routes/permissions";
import { hasPermission } from "../../../../utils/functions";
import ExtraContent from "../../../Configuration/CommonComponents/ExtraContent";
import FilterComponent from "../../../Configuration/CommonComponents/FilterComponent";
import UserListTable from "./UserListTable";
import { useSelector } from "react-redux";

const UserList = (props) => {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [page, setPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const [userList, setUserList] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  // Redux
  const dispatch = useDispatch();

  // Antd
  const { Title } = Typography;

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const filterData = useSelector(({ filter }) => filter.filterData);

  const getAllUsers = async (filterValues) => {
    const query = `${GET_DIGITALIZATION_APP_USERS}`;
    const bodyData = {
      page: page,
      per_page: filterValues?.per_page || 10,
      ...(filterValues?.name && { name: filterValues?.name }),
      ...(filterValues?.email && { email: filterValues?.email }),
      ...(filterValues?.id_card_no && { id_card_no: filterValues?.id_card_no }),
      ...(filterValues?.role_id && { role_id: filterValues?.role_id }),
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setUserList(response?.data?.data?.data);
      setPageSize(response?.data?.data?.per_page);
      setTotal(response?.data?.data?.total);
    } else {
      HandleNotification("error", "Error", "Something went wrong");
    }
  };

  useEffect(() => {
    getAllUsers({ ...filterData, per_page: pageSize, page: page });
  }, [refresh, filterData, page, pageSize]);

  const refetch = () => {
    setRefresh(refresh + 1);
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDelete = (event, record) => {
    dispatch(onDeleteUser(record));
    refetch();
  };

  const handleEdit = (event, record) => {
    dispatch(onGetUserDetails(record.id));
    navigate("/settings/users/create-user", { state: record });
  };
  const filterName = "users_list";
  const tableColumns = [
    { title: "Name", dataIndex: "name", key: "name", width: "15%" },
    { title: "Email", dataIndex: "email", key: "email", align: "center" },
    { title: "Phone Number", dataIndex: "phone", key: "phone", align: "center" },
    { title: "Id Card No", dataIndex: ["additional_info", "id_card_no"], key: "id_card_no", align: "center" },
    { title: "Role", dataIndex: ["role_info", "name"], key: "name", align: "center" },
    {
      title: "Department",
      dataIndex: ["department_info", "title"],
      key: "title",
      align: "center",
    },
    {
      title: "User Status",
      dataIndex: "user_status",
      key: "user_status",
      render: (value, record) => {
        if (value) {
          if (record.user_status === "Active") {
            return <Tag color="green">{record?.user_status}</Tag>;
          } else {
            return <Tag color="red">{record?.user_status}</Tag>;
          }
        } else {
          return <Tag color="green">Active</Tag>;
        }
      },
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   width: "15%",
    //   render: (_, record) => (
    //     <div>
    //       <Popconfirm
    //         title="Are you sure you want to delete?"
    //         onConfirm={(event) => handleDelete(event, record)}
    //       >
    //         <Button
    //           size="small"
    //           danger
    //           style={{ marginLeft: 5 }}
    //           disabled={!hasPermission([USER_DELETE_PERMISSION])}
    //         >
    //           Delete
    //         </Button>
    //       </Popconfirm>

    //       <Button
    //         style={{ marginLeft: 5 }}
    //         size="small"
    //         onClick={(event) => {
    //           handleEdit(event, record);
    //         }}
    //         disabled={!hasPermission([USER_EDIT_PERMISSION])}
    //       >
    //         Edit
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  const handleNav = (event, record) => {
    navigate("/settings/users/create-user", {
      state: props.selectedUserDetails,
    });
  };

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const extra = (
    <Button
      type="primary"
      size="small"
      onClick={handleNav}
      disabled={!hasPermission([USER_CREATE_PERMISSION])}
    >
      {hasPermission([USER_CREATE_PERMISSION]) ? "Add New" : "No Permission"}
    </Button>
  );

  const header = (
    <AppPageHeader
      extra={
        <ExtraContent
          hasImportButton
          uploadAPI={"/api/digitalization/user-import"}
          hideAddButton
          refresh={refresh}
          setRefresh={setRefresh}
          disabled={!hasPermission([USER_CREATE_PERMISSION])}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
        />
      }
      title={<Title level={5}>Users</Title>}
    />
  );
  const content = (
    <>
      <FilterComponent
        tableData={userList}
        filterAPI={getAllUsers}
        showFilter={showFilter}
        filterName={filterName}
        setShowFilter={setShowFilter}
      />
      <UserListTable
        onChange={(newPage) => {
          onPageChange(newPage);
        }}
        total={total}
        current={page}
        defaultCurrent={page}
        pageSize={pageSize}
        dataSource={userList}
        tableColumns={tableColumns}
        pagination={true}
      />
    </>
  );
  return (
    <>
      <AppContent header={header} content={content} />
    </>
  );
};

export default UserList;
